module.exports = __webpack_public_path__ + "static/img/yt.9617c29e.png";